
import React, { Fragment, useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { Button }from '@cmsgov/design-system';


// Components

import Form from '../../../../lib/wrappers/Form';
import MailingAddressInputs from '../../../ssap/pages/pageIncludes/common/address/MailingAddressInputs';
import ModalHeader from '../../../common/headers/ModalHeader';

// Utils

import { cloneObject } from '../../../../utils/miscellaneous/cloneObject';
import validators from '../../../../utils/validators/validators';
import { omit } from '../../../../utils/miscellaneous/objectHelpers';

// Constants

import { VALIDATION_TYPES } from '../../../../constants/inputs/validationTypes';




const MailingAddressUpdatingModal = props => {

    const MAILING_ADDRESS_FORM = 'mailingAddressForm';
    const PAGE_NAME = 'COMMUNICATION_PREFERENCES';

    const {
        actions: {
            fetchCountiesForZipcode,
            hideModal,
            setCounty,
            validateAddress
        },
        bottomAnchors: [
            anchor_1,
        ],
        boundAnchor,
        counties,
        methods,
        modal: {
            modalData: {
                actionNames: {
                    SUBMIT_CLICK
                },
                data,
                handleAddressSave,
                isDashboardLocation,
                mailingAddress
            }
        },
        modalHeaderProps
    } = props;

    const fetchedCounties = (cc => cc ? cc : [])(counties[PAGE_NAME]);


    const [ address, updateAddress ] = useState(mailingAddress);

    const {
        postalCode: _postalCode,
        countyCode: _countyCode,
        streetAddress1: _streetAddress1,
        streetAddress2: _streetAddress2,
        state: _state,
        city: _city
    } = address;

    const isPostalCodeValid = validators
        .find(validator => validator.validatorType === VALIDATION_TYPES.ZIP_CODE)
        .verifier({ value: _postalCode });

    useEffect(() => {
        if(_state && isPostalCodeValid) {
            fetchCountiesForZipcode(_state, _postalCode.slice(0, 5), PAGE_NAME);
        }
    }, [ `${_state}${_postalCode}` ]);

    useEffect(() => {
        if(fetchedCounties.length === 1) {

            const { countyCode } = fetchedCounties
                .reduce((res, c) => {
                    const [ countyCode ] = Object.entries(c)[0];
                    return {
                        ...res,
                        countyCode
                    };
                }, {});

            updateAddress(localState => ({
                ...localState,
                countyCode
            }));
        }
    }, [ fetchedCounties.map(c => Object.keys(c)).toString() ]);

    useEffect(() => {
        if(!isPostalCodeValid) {
            fetchedCounties.length > 0 && setCounty([], PAGE_NAME);

            updateAddress(localState => ({
                ...localState,
                countyCode: null
            }));
        }
    }, [ _postalCode ]);

    const handleClick = e => {

        const {
            dataset: {
                action_name,
                form_name
            }
        } = e.currentTarget;

        methods[form_name][action_name]();
    };

    const onFieldChange = (...args) => {
        const [ newData ] = args;

        updateAddress(data => {

            const mixin = newData.postalCode !== address.postalCode
                ? { countyCode: null }
                : { };

            return {
                ...data,
                ...newData,
                ...mixin
            };
        });
    };

    const handleHideClick = () => {
        hideModal();
    };

    const saveUpdatedMailingAddress = addressFromModal => {
        handleAddressSave({
            ...data,
            mailingAddress: omit({ ...address, ...addressFromModal }, [ 'primaryAddressCountyFipsCode', 'county' ])
        }, hideModal);
    };

    const handleMailingAddressSave = () => {
        validateAddress(
            saveUpdatedMailingAddress,
            {
                addressLine1: _streetAddress1,
                addressLine2: _streetAddress2,
                city: _city,
                state: _state,
                zipcode: _postalCode
            }
        );
    };

    const isCloseButtonsHidden = !isDashboardLocation && !mailingAddress.streetAddress1;

    return (
        <Fragment>
            <div className="gi-modal__header__head">
                <ModalHeader { ...{ ...modalHeaderProps, hideCloseIcon: isCloseButtonsHidden } } />
            </div>
            <div id="mailingAddressUpdatingModal" className="gi-modal__body">
                <Form
                    { ...{
                        data: address,
                        formName: MAILING_ADDRESS_FORM,
                        onLocalFormSubmit: handleMailingAddressSave
                    } }
                >
                    <MailingAddressInputs
                        {...{
                            _postalCode,
                            _countyCode,
                            _streetAddress1,
                            _streetAddress2,
                            _state,
                            _city,
                            currentData: cloneObject(address),
                            counties: fetchedCounties,
                            fields: [],
                            inputActions: {
                                onFieldChange
                            },
                            underFormControl: true
                        }}
                    />
                </Form>
            </div>
            <div className='gi-modal__footer'>
                <div className='grid-row controls'>
                    <div className={`grid-offset-${isCloseButtonsHidden ? '5' : '4'} txt-left`}>
                        <Button
                            className='usa-button gi-button gi-button__primary'
                            data-form_name={MAILING_ADDRESS_FORM}
                            data-action_name={SUBMIT_CLICK}
                            onClick={handleClick}
                        >
                            <FormattedMessage id='button.save_mailing_address'/>
                        </Button>

                        {
                            isCloseButtonsHidden ?
                                
                                null:

                                <Button
                                    className='usa-button usa-button--outline gi-button gi-button__outline'
                                    onClick={handleHideClick}
                                    inputRef={boundAnchor(anchor_1)}
                                >
                                    <FormattedMessage id='button.cancel_changes'/>
                                </Button>
                        }
                    </div>
                </div>
            </div>
        </Fragment>

    );
};

export default MailingAddressUpdatingModal;